<script lang="ts">
	import type { PageBuilderBlock } from "#lib/types/spotprisenContent.js";
	import type { ResolvedLandingPage } from "#lib/fetch/landingPage.js";
	import { setContext } from "svelte";
	import lang from "#lib/langStore.js";
	import MetaData from "#lib/MetaData.svelte";
	import CoverBlock from "#lib/CoverPicture.svelte";
	import PageBuilder from "#lib/PageBuilder.svelte";
	import theTime from "@ishavskraft/the-time";

	interface Props {
		page: ResolvedLandingPage | null;
		/** Set by the Presentation preview route, which must never be indexed. */
		noIndex?: boolean;
	}

	let { page, noIndex = false }: Props = $props();

	// Shared pageBuilder blocks (e.g. CustomerReviews, OtherDeals) read the
	// language via this context — provide it as avtale/spotpris/historikk do.
	setContext("page-lang", () => page?.language ?? $lang ?? "nb");
	let seo = $derived(page?.seo);
	let blocks = $derived((page?.pageBuilder ?? []) as unknown as PageBuilderBlock[]);
	let firstBlock = $derived(blocks[0]);
	let topCover = $derived(firstBlock?._type === "cover" ? firstBlock.cover : null);
	// The first cover block renders as the <h1> below; hand the rest to the
	// shared dispatcher so it isn't drawn twice.
	let builderBlocks = $derived(topCover ? blocks.slice(1) : blocks);
</script>

<MetaData
	data={{
		title: seo?.title || page?.title,
		description: seo?.description || "",
		noIndex: noIndex || seo?.noIndex,
		...(seo?.image || {}),
	}}
/>

{#if topCover}
	<CoverBlock image={topCover.image}>
		<h1 class="my-0 text-h-hero font-title tablet:leading-tight">
			{topCover.title || page?.title}
		</h1>
	</CoverBlock>
{:else}
	<div class="mx-edge-x laptop:mx-auto max-w-prose">
		<h1>{page?.title}</h1>
	</div>
{/if}

{#if page?.showDate}
	<div class="mx-edge-x laptop:mx-auto max-w-prose">
		<p class="italic text-sm">
			Sist oppdatert {theTime(page?._updatedAt).toLocaleDateString("nb-NO", {
				year: "numeric",
				month: "long",
				day: "numeric",
			})}
		</p>
	</div>
{/if}

<PageBuilder blocks={builderBlocks} />
